import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import config from './modules/config'
import user from './modules/user'
import ficha from './modules/ficha'
import share from './modules/share'

Vue.config.devtools = true
const debug = true // process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    strict: debug,
    modules: {
        config,
        user,
        ficha,
        share
    }
})